import { Col, Row } from "antd";
import FacebookIcon from "assets/images/logo/facebook.svg";
import LinkedinIcon from "assets/images/logo/linkedin.svg";
import YoutubeIcon from "assets/images/logo/youtube.svg";
import ZaloIcon from "assets/images/logo/zalo.svg";
import { BCT_LOGO, VBC_LOGO } from "constants/images";

const Footer = () => {
  return (
    <div className="bg-[#2A2A2A] py-5">
      <div className="container max-w-full lg:max-w-[95vw]">
        <Row gutter={[32, 32]} className="pt-5">
          <Col span={24} md={12} className="flex flex-col">
            <div className="flex items-center justify-start mb-3 lg:mb-5">
              <div
                onClick={() => {
                  window.open("https://vietnamblockchain.asia/");
                }}
                className="relative w-[180px] h-[70px] lg:w-[200px] cursor-pointer"
              >
                <img src={VBC_LOGO} alt="" className="object-contain mb-5" />
              </div>
            </div>
            <div className="block lg:hidden mb-5">
              <p className="text-high-white mb-2 text-sm text-justify">
                {/* Giải pháp xác thực chữ ký số dựa trên nền tảng công nghệ Blockchain xác minh tính hợp lệ và nguồn gốc
                bằng cấp, chứng chỉ và tài liệu số */}
                A digital signature verification solution based on Blockchain
                technology validates the authenticity and origin of diplomas,
                certificates, and digital documents.
              </p>
            </div>
            <div className="flex flex-col items-start">
              <p className="text-white font-bold mb-2 text-sm lg:text-medium">
                {/* Thông tin liên hệ */}
                Contact Information
              </p>
              <p className="text-high-white mb-2 text-sm lg:text-medium">
                {/* Điện thoại: (+84) 28 6271 7798 */}
                Phone: (+84) 28 6271 7798
              </p>
              <p className="text-high-white mb-2 text-sm lg:text-medium">
                Email: contact@vietnamblockchain.asia
              </p>
              <p className="text-high-white mb-2 text-sm lg:text-medium">
                {/* Địa chỉ: 28/3 Lữ Gia, Phường 15, Quận 11, Thành phố Hồ Chí Minh */}
                Address: 28/3 Lu Gia, Ward 15, District 11, Ho Chi Minh City
              </p>
              <p className="text-high-white mb-2 text-sm lg:text-medium">
                Website: vietnamblockchain.asia
              </p>
            </div>
          </Col>
          <Col span={24} md={12} lg={6} className="md:mt-5">
            <div className="flex flex-col items-start">
              <p className="text-white font-bold mb-2 text-sm lg:text-medium">
                {/* Về chúng tôi */}
                About Us
              </p>
              <p
                onClick={() =>
                  window.open("https://vietnamblockchain.asia/overview")
                }
                className="text-high-white mb-2 text-sm lg:text-medium hover:text-white duration-200 cursor-pointer"
              >
                {/* Về VBC */}
                About VBC
              </p>
              <p
                onClick={() =>
                  window.open("https://vietnamblockchain.asia/#history-section")
                }
                className="text-high-white mb-2 text-sm lg:text-medium hover:text-white duration-200 cursor-pointer"
              >
                {/* Lịch sử & Phát triển */}
                History & Development
              </p>
              <p
                onClick={() =>
                  window.open("https://vietnamblockchain.asia/#service-section")
                }
                className="text-high-white mb-2 text-sm lg:text-medium hover:text-white duration-200 cursor-pointer"
              >
                {/* Dịch vụ */}
                Services
              </p>
              <p
                onClick={() =>
                  window.open("https://vietnamblockchain.asia/products")
                }
                className="text-high-white mb-2 text-sm lg:text-medium hover:text-white duration-200 cursor-pointer"
              >
                {/* Sản phẩm */}
                Products
              </p>
              <p
                onClick={() =>
                  window.open(
                    "https://vietnamblockchain.asia/impressive-projects"
                  )
                }
                className="text-high-white mb-2 text-sm lg:text-medium hover:text-white duration-200 cursor-pointer"
              >
                {/* Dự án */}
                Projects
              </p>
              <p
                onClick={() =>
                  window.open("https://vietnamblockchain.asia/media")
                }
                className="text-high-white mb-2 text-sm lg:text-medium hover:text-white duration-200 cursor-pointer"
              >
                {/* Truyền thông */}
                Media
              </p>
            </div>
          </Col>
          <Col span={24} lg={6} className="lg:mt-auto">
            <div className="flex items-center justify-start">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={
                  "https://www.youtube.com/channel/UC7k1WHzYlMhGzHJHH0yN1yQ"
                }
                className="mr-2"
              >
                <img src={YoutubeIcon} alt="" width={33} height={30} />
              </a>

              <a
                target="_blank"
                rel="noopener noreferrer"
                href={"https://www.facebook.com/vietnamblockchaincorporation"}
                className="mr-2"
              >
                <img src={FacebookIcon} alt="" width={25} height={30} />
              </a>

              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.zalo.me/3353504899459377778"
                className="mr-1"
              >
                <img src={ZaloIcon} alt="" width={30} height={30} />
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={
                  "https://www.linkedin.com/authwall?trk=bf&trkInfo=AQEYaBB5mvHXtAAAAYsagnwof_jlE9qj_qlWUlrW-2ap5V7QzrKJnPwLiTsyCkTFfqvKUsBzCC3YYjL_S7rUFebl3x-14IkO_WX4hlQvKHRqTfDM2yO6JTifJCVjZMhwRQFpNL4=&original_referer=&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Fvietnamblockchain%2F"
                }
              >
                <img src={LinkedinIcon} alt="" width={33} height={30} />
              </a>
            </div>
            <div className="relative w-[160px] h-[60px] lg:w-[150px] lg:h-[100px] lg:mb-5 mt-2">
              <img src={BCT_LOGO} alt="" className="object-contain" />
            </div>
          </Col>
        </Row>
        <div className="border-t-[1px] border-solid border-t-high-white mt-5 pt-5">
          <div className="flex flex-wrap items-center justify-between">
            <p className="text-xs text-high-white leading-relaxed my-2">
              {/* © Công ty Cổ phần Vietnam Blockchain 2024
              <br />
              Đã đăng ký bản quyền */}
              © Vietnam Blockchain Corporation 2024
              <br />
              All Rights Reserved
            </p>
            <p
              className="text-xs text-high-white hover:text-white duration-200 cursor-pointer"
              onClick={() =>
                window.open("https://vietnamblockchain.asia/private-policy")
              }
            >
              {/* Điều khoản & Điều kiện . Chính sách bảo mật */}
              Terms & Conditions · Privacy Policy
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
